/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';

const ProductInfo = ({ products }) => {
  if (!products || products.length === 0) {
    return null;
  }

  if (products.length === 1) {
    const { identifiers, media } = products?.[0] || {};

    const image = media?.images?.find(
      (img) => img.type === 'IMAGE' && img.subType === 'PRIMARY'
    );

    return (
      <div className="sui-grid sui-grid-cols-12">
        <div className="sui-col-span-12">
          <div className="sui-flex sui-flex sui-flex-row" data-testid="product-info">
            <img
              src={image?.url.replace('<SIZE>', '145')}
              alt={identifiers?.productLabel}
              className="sui-aspect-square sui-max-w-[20%] sm:sui-max-w-[30%]"
              width="120"
              height="120"
            />
            <div className="sui-pl-6">
              <Typography weight="bold">{identifiers?.brandName}</Typography>
              <Typography lineClamp="2">{identifiers?.productLabel}</Typography>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Typography weight="bold">Add {products.length} items</Typography>
      <ul className="sui-mt-1 sui-list-disc sui-list-inside sui-overflow-hidden">
        {products.slice(0, 3).map((product) => (
          <li className="sui-overflow-hidden sui-text-ellipsis sui-truncate" key={product.itemId}>
            <Typography component="span" weight="bold">
              {product?.identifiers?.brandName}
            </Typography>
            &nbsp;
            <Typography component="span" truncate>
              {product?.identifiers?.productLabel}
            </Typography>
          </li>
        ))}
      </ul>
      {products.length > 3 && (
        <div className="sui-ml-2">
          <Typography>+{products.length - 3} more</Typography>
        </div>
      )}
    </div>
  );
};

ProductInfo.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      itemId: PropTypes.string.isRequired,
      quantity: PropTypes.number.isRequired,
      fulfillmentLocation: PropTypes.string.isRequired,
      fulfillmentMethod: PropTypes.string.isRequired,
      identifiers: PropTypes.shape({
        brandName: PropTypes.string,
        productLabel: PropTypes.string
      }).isRequired,
      pricing: PropTypes.shape({
        value: PropTypes.number
      }).isRequired,
      media: PropTypes.shape({
        images: PropTypes.arrayOf(
          PropTypes.shape({
            altText: PropTypes.string,
            sizes: PropTypes.arrayOf(PropTypes.string),
            subType: PropTypes.string,
            type: PropTypes.string,
            url: PropTypes.string
          })
        )
      })
    })
  ).isRequired
};

ProductInfo.displayName = 'ProductInfo';

export { ProductInfo };
